import React from 'react';
import { SlideNav } from './SlideNav';
import { SnakkerMark } from './SnakkerMark';
type Tone = 'paper' | 'accent';
type SlideFrameProps = {
  /** Running wayfinding label, e.g. "Step 02 — Perception". */
  marker?: string;
  /** Right-hand footer label. */
  meta?: string;
  tone?: Tone;
  /** Closing slide — swaps Next for Replay. */
  isLast?: boolean;
  children: React.ReactNode;
};
export function SlideFrame({
  marker,
  meta = 'Prepared for LEO Pharma · Established brand optimization',
  tone = 'paper',
  isLast = false,
  children
}: SlideFrameProps) {
  const accent = tone === 'accent';
  return <section className={['flex h-full w-full flex-col overflow-hidden px-[6%] pt-[3.4%] pb-[2.6%]', accent ? 'bg-gapAccent text-white' : 'bg-paper text-ink'].join(' ')} data-id="element-53" data-mp="29uj04dl2dd97">
      <header className="flex shrink-0 items-center justify-between gap-[4%]" data-id="element-54" data-mp="yhgmnre9h3t9">
        <span className={['truncate text-[clamp(9px,1vw,16px)] font-semibold uppercase tracking-[0.16em]', accent ? 'text-white/75' : 'text-gapAccent'].join(' ')} data-id="element-55" data-mp="tgsrqumww2tr">
          {marker}
        </span>
        <SnakkerMark tone={tone} className="shrink-0" data-id="element-56" data-mp="1jhrplhk0fl35" />
      </header>

      <div className="flex min-h-0 flex-1 flex-col justify-center" data-id="element-57" data-mp="14lsa3lukminz">
        {children}
      </div>

      <footer className={['mt-[1.8vh] flex shrink-0 items-center justify-between gap-[4%] border-t pt-[1.4vh]', accent ? 'border-white/25' : 'border-ink-line'].join(' ')} data-id="element-58" data-mp="19kd8rgu6cuab">
        <p className={['truncate text-[clamp(8px,0.85vw,13px)] font-medium', accent ? 'text-white/70' : 'text-ink-mute'].join(' ')} data-id="element-59" data-mp="10mb3uq7blhhr">
          Snakker thoughts-material — for discussion, not a final
          recommendation. <span aria-hidden="true" data-id="element-60" data-mp="cwp4o2qy729r">·</span> {meta}
        </p>
        <SlideNav tone={tone} isLast={isLast} data-id="element-61" data-mp="gwr92jo2i9sq" />
      </footer>
    </section>;
}
type SlideTitleProps = {
  children: React.ReactNode;
  sub?: React.ReactNode;
  tone?: Tone;
  size?: 'hero' | 'section';
};
export function SlideTitle({
  children,
  sub,
  tone = 'paper',
  size = 'section'
}: SlideTitleProps) {
  const accent = tone === 'accent';
  return <div className="shrink-0" data-id="element-62" data-mp="29u4m0db8aydu">
      <h2 className={['font-display leading-[1.02] tracking-[-0.005em]', size === 'hero' ? 'text-[clamp(38px,6vw,100px)]' : 'text-[clamp(26px,4vw,64px)]', accent ? 'text-white' : 'text-ink'].join(' ')} data-id="element-63" data-mp="24us1hz7ty3ef">
        {children}
      </h2>
      {sub && <p className={['mt-[1.2vh] max-w-[62ch] text-[clamp(12px,1.35vw,22px)] leading-[1.45]', accent ? 'text-white/80' : 'text-ink-soft'].join(' ')} data-id="element-64" data-mp="2sjkz0043ojb5">
          {sub}
        </p>}
    </div>;
}